import React from "react";
import BranchForm from "./branchFormWrapper/BranchForm";

export default function BranchFormWrapper({ADD_BRANCH, UPDATE_BRANCH}){
    let props = {
        ADD_BRANCH, 
        UPDATE_BRANCH
    };
    
    return (
        <BranchForm props={props}/>
    );
}


// WEBPACK FOOTER //
// ./src/components/general/BranchFormWrapper.jsx